// src/channel-partners/adminDevelopersApi.ts
import { apiClient } from "@maat/api-base";
var adminDevelopersApi = {
  /** Every workspace that has asked for access, most recently active first. */
  list: async (params) => apiClient.get("/main/api/admin/channel-partners/developers", { params })
};

export {
  adminDevelopersApi
};
